import { format } from 'd3-format';
import { FC } from 'react';

import { MonitoringDateRange } from '../../monitoring/DateRange-Dropdown-util';
import { X_AXIS_LABEL } from '../../monitoring/GraphContainer';
import { interval } from '../../../feature/feature-services/feature-service/component/ChartDefaultParams';

// generated
import { FCOFields, FeatureViewFCO } from '../../../core/types/fcoTypes';

// @tecton
import PrometheusMonitoring from '@tecton/ComponentRedesign/Charts/PrometheusMonitoring';
import { filterDataForTableViewsOnly } from './utils';

interface FeatureViewsBelowFreshnessThresholdProps {
  featureViews: FeatureViewFCO[];
  graphType: number;
  monitoringDateRange: MonitoringDateRange;
}

const DynamoDBP99RowCount: FC<FeatureViewsBelowFreshnessThresholdProps> = ({
  monitoringDateRange,
  featureViews,
  graphType,
}) => {
  const chartTitle = '';
  const yAxisLabel = 'Row Count';

  const query = `histogram_quantile(0.${graphType}, sum(rate(dynamodb_rows_per_query_bucket_rollup_no_pod{
    aws_region=~".*",
    tecton_cluster=~".*"
  }[${interval}])) by (table,le))`;

  const yTicksCallback = (value: any) => {
    const formatter = format('.2~f');
    return `${formatter(value)}`;
  };

  const toolTipLabelCallback = (context: any) => {
    const { y } = context.parsed;
    const formatter = format('.2~f');
    const { label } = context.dataset;
    const value = formatter(y);

    const labelText = `${label}: ${value}`;
    return labelText;
  };

  const getMetricLabelCallback = (result: any, label?: string) => {
    // Matches the Feature View ID (which is in the dataset)
    // to the Feature View Name (which is in FeatureViews)
    // Ensures that charts render properly

    const findMatchingId = featureViews.find((featureView) => result.metric.table.includes(featureView[FCOFields.ID]));
    if (findMatchingId) {
      return `P${graphType}:${findMatchingId[FCOFields.NAME]!}`;
    }
    return '';
  };

  const yOverride = {
    title: {
      display: true,
      text: yAxisLabel,
      font: {
        size: 12,
      },
    },
    min: 0,

    ticks: {
      callback: yTicksCallback,
    },
  };

  return (
    <>
      <PrometheusMonitoring
        chartTitle={chartTitle}
        monitoringDateRange={monitoringDateRange}
        queries={[{ label: `P${graphType}`, query: query }]}
        xAxisLabel={X_AXIS_LABEL}
        yAxisLabel={yAxisLabel}
        yTicksCallback={yTicksCallback}
        yGrace={0}
        toolTipLabelCallback={toolTipLabelCallback}
        yOverride={yOverride}
        parseValue={parseFloat}
        getMetricLabelCallback={getMetricLabelCallback}
        height={160}
        transformData={(data) => {
          return filterDataForTableViewsOnly(data, featureViews);
        }}
      />
    </>
  );
};

export default DynamoDBP99RowCount;
